import {encryptionKeyMap} from "@/brand/encryptionKeys";
import {brandConfigObjectMap} from "@/brand/brandConfig";
import {termsAndConditionsMap} from "@/brand/termsAndConditions";

export const brandConfigMap = new Map();

brandConfigMap.set('http://localhost:8080', getBrandConfig('saf-ke-en'));
brandConfigMap.set('http://localhost:8081', getBrandConfig('mtn-nga-en'));
// brandConfigMap.set('https://cg.mtnfantasyfootball.com', getBrandConfig('mtn-cg-fr'));
// brandConfigMap.set('https://ci.mtnfantasyfootball.com', getBrandConfig('mtn-ci-fr'));
// brandConfigMap.set('https://cm.mtnfantasyfootball.com', getBrandConfig('mtn-cmr-fr'));
// brandConfigMap.set('https://gh.mtnfantasyfootball.com', getBrandConfig('mtn-gha-en'));
// brandConfigMap.set('https://ar.fantasy.penrosegaming.com', getBrandConfig('demo-arabic'));
// brandConfigMap.set('https://ro.fantasy.penrosegaming.com', getBrandConfig('demo-romanian'));
// brandConfigMap.set('https://ng.mtnfantasygames.com', getBrandConfig('mtn-nga-en'));
// brandConfigMap.set('https://www.mtn-ffootball.com', getBrandConfig('mtn-zam-en'));
// brandConfigMap.set('https://mtn-ffootball.com', getBrandConfig('mtn-zam-en'));
// brandConfigMap.set('https://ng.airtel-fantasygames.com', getBrandConfig('air-nga-en'));
brandConfigMap.set('https://ke-fantasyfootball-one.migration.penrosesystems.com', getBrandConfig('saf-ke-en'));
brandConfigMap.set('https://ke-mplay.fantasyfootball.one', getBrandConfig('saf-ke-en'));
brandConfigMap.set('https://ethiofantasy.com', getBrandConfig('ethiotel-et-en'));
brandConfigMap.set('https://demo-en-fantasy-penrosegaming-com.migration.penrosesystems.com', getBrandConfig('saudi-uae-en'));
brandConfigMap.set('https://telkom-fantasyfootball-one.migration.penrosesystems.com', getBrandConfig('tlk-za-en'));
brandConfigMap.set('https://fantasysoccer-vodacomfantasy-com.migration.penrosesystems.com', getBrandConfig('vc-za-en'));
brandConfigMap.set('https://fantasysoccer-vodacomfantasy-com.migration.penrosesystems.com', getBrandConfig('vc-za-en'));
brandConfigMap.set('https://ais-fantasy-penrosegaming-com.migration.penrosesystems.com', getBrandConfig('ais-tai-en'));
brandConfigMap.set('https://dtac-fantasy-penrosegaming-com.migration.penrosesystems.com', getBrandConfig('dtac-tai-tha'));
brandConfigMap.set('https://th-championshipmanagers-com.migration.penrosesystems.com', getBrandConfig('ais-tai-tha'));

// Deployed migration-clients hosts are *.migration.penrosesystems.com (the entries above used a stale "-1"
// suffix that never matched window.origin, so every host fell through to default=vc-za-en and redirected to
// the Vodacom entry portal). Map each deployed host to its own brand so it serves that brand, not Vodacom.
brandConfigMap.set('https://digitalfantasysport-com.migration.penrosesystems.com', getBrandConfig('mtn-nga-en'));
brandConfigMap.set('https://ng-mtnfantasyfootball-com.migration.penrosesystems.com', getBrandConfig('mtn-nga-en'));
brandConfigMap.set('https://ci-mtnfantasygames-com.migration.penrosesystems.com', getBrandConfig('mtn-ci-fr'));
brandConfigMap.set('https://cm-mtnfantasygames-com.migration.penrosesystems.com', getBrandConfig('mtn-cmr-fr'));
brandConfigMap.set('https://ke-fantasyfootball-one.migration.penrosesystems.com', getBrandConfig('saf-ke-en'));
brandConfigMap.set('https://telkom-fantasyfootball-one.migration.penrosesystems.com', getBrandConfig('tlk-za-en'));
brandConfigMap.set('https://th-championshipmanagers-com.migration.penrosesystems.com', getBrandConfig('ais-tai-tha'));
brandConfigMap.set('https://ais-fantasy-penrosegaming-com.migration.penrosesystems.com', getBrandConfig('ais-tai-en'));
brandConfigMap.set('https://dtac-fantasy-penrosegaming-com.migration.penrosesystems.com', getBrandConfig('dtac-tai-tha'));
brandConfigMap.set('https://demo-en-fantasy-penrosegaming-com.migration.penrosesystems.com', getBrandConfig('saudi-uae-en'));
brandConfigMap.set('https://demo-ro-fantasy-penrosegaming-com.migration.penrosesystems.com', getBrandConfig('demo-romanian'));
brandConfigMap.set('https://demo-fantasy-penrosegaming-com.migration.penrosesystems.com', getBrandConfig('demo-arabic'));

brandConfigMap.set('default', getBrandConfig('vc-za-en'));

export function getBrandConfig(brand) {
    const brandConfigObject = brandConfigObjectMap.get(brand);
    return {
        brand,
        revenuePartnerId: brandConfigObject.revenuePartnerId,
        isRandomDrawAwarded: brandConfigObject.isRandomDrawAwarded,
        tabTitle: brandConfigObject.tabTitle,
        userAccessId: brandConfigObject.userAccessId,
        encryptionKey: encryptionKeyMap.get(brand),
        termsAndConditionsMap: termsAndConditionsMap.get(brand),
        googleTag: brandConfigObject.googleTag,
        productId: brandConfigObject.productId,
        isAwardingMinutes: brandConfigObject.isAwardingMinutes,
        isRTL: brandConfigObject.isRTL || false,
        language: brandConfigObject.language || 'en',
        notUpstreamService: brandConfigObject.notUpstreamService,
        showPrizes: brandConfigObject.showPrizes
    }
}
